import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service';
import { HttpClient } from '@angular/common/http';
import { configObj } from '../configuration';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class CreatepinService {

  constructor(
    private commonServices:CommonService,
    private http: HttpClient,
    private router:Router
  ) { }

    
  postCreatedPin(cvvNo,createPin,reCreatePin,expiryDate,pinReqToken){
    var url = configObj.baseUrl + '/user/crd/process/request/'
    var requestBody = {
      "id": pinReqToken,
      "requestData": {
          "pin":this.commonServices.generateEncRequest(createPin),
          "confirmPin": this.commonServices.generateEncRequest(reCreatePin),
          // "expiryDate":this.commonServices.generateEncRequest(expiryDate),
          // "cardCvv":this.commonServices.generateEncRequest(cvvNo)
         }
    }
    if(this.router.url && this.router.url.includes('createpin') ){
      requestBody['source'] = 'setupPin'
    }
    else{
      requestBody['source'] = 'changePinPopup'
    }
    return this.http.post(url,requestBody, this.commonServices.prepareHeaders());
  }


}
